import { useMemo } from "react";
import PropTypes from "prop-types";
import 'chart.js/auto';
import { Chart } from 'react-chartjs-2';
import Card from "@mui/material/Card";;
import MDBox from "components/MDBox";
import configs from "examples/Charts/BarCharts/ReportsBarChart/configs";

function ReportsBarChart({ color, chart }) {
  const { data, options } = configs(chart?.labels || [], chart?.datasets || {});

  return (
    <Card sx={{ height: "100%" }}>
      <MDBox padding="1rem">
        {useMemo(
          () => (
            <MDBox variant="gradient" bgColor={color} borderRadius="lg" coloredShadow={color} py={2} pr={0.5} height="17.5rem">
              <Chart type="bar" data={data} options={options} />
            </MDBox>
          ),
          [chart, color]
        )}
      </MDBox>
    </Card>
  );
}

ReportsBarChart.defaultProps = {
  color: "dark",
};

ReportsBarChart.propTypes = {
  color: PropTypes.oneOf(["primary", "secondary", "info", "success", "warning", "error", "dark"]),
  chart: PropTypes.objectOf(PropTypes.oneOfType([PropTypes.array, PropTypes.object])),
};

export default ReportsBarChart;
